import { useState, useEffect } from 'react';
import { getReporteVentas } from '../../../../service/reportes/ReporteVentas';

export interface DetalleVenta {
  folio_ticket: string;
  evento: string;
  venta_id: number;
  fecha_hora_venta: string;
  producto: string;
  cantidad: number;
  precio_unitario: number;
  total_venta: number;
  forma_pago: string;
  punto_venta_id: number;
  punto_venta: string;
  tipo_punto_venta: string;
}

export interface ResumenVenta {
  folio_ticket: string;
  evento: string;
  saldo_actual: number;
  activo: number;
  folio_nuevo: string | null;
  saldo_recarga_caja: number;
  total_consumido_puesto: number;
  transferido: number;
  balance: number;
  fecha_primera_venta: string;
}

export interface TicketConVentas {
  folio: string;
  resumen: ResumenVenta;
  detalle: DetalleVenta[];
}

export const useReporteVentas = (ids_dia: number[]) => {
  const [list, setList] = useState<TicketConVentas[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(false);

  useEffect(() => {
    if (!ids_dia || ids_dia.length === 0) {
      setList([]);
      return;
    }
    const fetchData = async () => {
      setLoadingRequest(true);
      try {
        const data = await getReporteVentas(ids_dia);
        setList(data ?? []);
      } catch {
        setList([]);
      } finally {
        setLoadingRequest(false);
      }
    };
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids_dia.join(',')]);

  return { list, loadingRequest };
};
